import { createInterfaceId } from '@gitlab/needle';
import type { ChatLog } from '@gitlab-lsp/workflow-api';
import type { SessionEvent } from '../backend/backend';
import type { GetSessionHistoryOptions, SessionHistoryPage } from './session_history';

export interface SessionExportSource {
  chatLog: ChatLog[];
  /** The workflow's goal. */
  title?: string;
  flow?: string;
}

export interface SessionDataService {
  getSessionHistory(options: GetSessionHistoryOptions): Promise<SessionHistoryPage>;
  getSessionMessages(sessionId: string): Promise<SessionEvent[]>;
  getSessionChatLog(sessionId: string): Promise<ChatLog[]>;
  /** Undefined for an unknown id, which getSessionChatLog cannot express. */
  getSessionExportSource(sessionId: string): Promise<SessionExportSource | undefined>;
}

export const SessionDataService = createInterfaceId<SessionDataService>('SessionDataService');
